<template>
  <v-snackbar
    :model-value="true"
    location="bottom"
    color="success"
    class="toast"
    timeout="3000"
    transition="slide-y-reverse-transition"
  >
    <div class="d-flex align-center column-gap-4">
      <span v-t="{ path: 'project.documents.DocumentsMoveSnackbar.movementSnackbarSuccess', plural: documentsToMove.documents.length, args: { count : documentsToMove.documents.length } }"/>
    </div>
    <template #actions="{ attrs }" v-if="!isChecklist">
      <SnackBarButton class="mr-2 text-uppercase"
                      v-bind="attrs"
                      @click="cancelMove"
      >
      {{ $t('common.cancel') }}
      </SnackBarButton>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import SnackBarButton from '@/common/buttons/SnackBarButton.vue'
import { toast } from '@/common/utils/toast'
import { MOVE_FILDERS, LOAD_FOLDERS_TREE } from '@/store/modules/documents/action_types'
import { SET_MOVEMENT_SNACKBAR_IS_OPEN } from '@/store/modules/documents/mutation_types'

export default {
  name: 'DocumentsMoveSnackbar',
  components: { SnackBarButton },
  props: {
    isChecklist: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('documents', ['documentsToMove']),
  },
  methods: {
    ...mapActions('documents', [MOVE_FILDERS, LOAD_FOLDERS_TREE]),
    ...mapMutations('documents', [SET_MOVEMENT_SNACKBAR_IS_OPEN]),
    async cancelMove () {
      try {
           await this.MOVE_FILDERS({
             documents: this.documentsToMove.documents,
             targetFolderId: this.documentsToMove.originalFolderId,
           })
           toast.success(this.$t('project.documents.table.DocumentsTableBody.moveCancel'))
           this.onClose()
         } catch {
           toast.error(this.$t('project.documents.table.DocumentsTableBody.moveError'))
         }
      await this.LOAD_FOLDERS_TREE()
    },
    onClose () {
      this.SET_MOVEMENT_SNACKBAR_IS_OPEN(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.toast {
  :deep(.v-snack__wrapper) {
    margin: 40px;

    // max-width: 1264px match our mobile breakpoint
    @media only screen and (max-width: 1264px) {
      margin: 16px;
    }
  }
}
</style>
